export const TEAMS_FETCH = 'teams/FETCH';
export const TEAMS_RECEIVED = 'teams/RECEIVED';
export const TEAMS_ERROR = 'teams/ERROR';
// export const TEAMS_VIEW = 'teams/VIEW';

export const TEAMS_KEY = 'teams';

export const INITIAL_TEAMS = {
  loading: false,
  error: null,
  selectedId: null,
};

export const SORTED_DIVISIONS = [
  'East',
  'North',
  'South',
  'West',
];



// WEBPACK FOOTER //
// ./src/store/actions/teams.types.js